<template lang="html">

  <article class="observacion">
    <p class="status" :type="data.estado">{{data.estado}}</p>
    <p class="fecha">{{data.fecha}}</p>
    <p class="observacion-text" v-if="data.observacion" v-html="data.observacion"></p>
    <arrow-link :text="'Ver Adjunto'" :external="true" :to="data.urlAdjunto" :blank="true" v-if="data.urlAdjunto"></arrow-link>
  </article>

</template>

<script lang="js">

  import arrowlink  from '@/components/parts/icons/arrow-link';

  export default  {
    name: 'observacion-el',
    props: ['data'],
    components : {
      'arrow-link' : arrowlink,
    }
  }
</script>

<style scoped lang="scss">
    
    .observacion{
      width: 100%;
      display: inline-block;
      text-align: left;
      margin-bottom: 10px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 10px;

      .fecha{
        font-size: 14px;
        margin-bottom: 10px;
      }
      
      .status{
        font-size: 12px;
        text-transform: uppercase;
        display: inline-block;
        font-weight: 700;
        margin-bottom: 5px;
        &[type="rechazada"]{
          color: red;
        }
      }

      .observacion-text{
        font-size: 16px;
        width: 100%;
        text-align: left;
        margin-bottom: 5px;
      }

      *:last-of-type{
        margin-bottom: 0;
      }

    }

</style>



// WEBPACK FOOTER //
// src/components/parts/observacion-el.vue